import type { TooltipDesignTokens, TooltipTokenSections } from '@primeuix/themes/types/tooltip';

// Rebrand 2026 (DS): ink tooltip, 8px radius
export const root: TooltipTokenSections.Root = {
    maxWidth: '12.5rem',
    gutter: '0.25rem',
    shadow: '{overlay.popover.shadow}',
    padding: '6px 10px',
    borderRadius: '{borderRadius.sm}'
};

export const colorScheme: TooltipTokenSections.ColorScheme = {
    light: {
        root: {
            background: '{extend.surfacedark}',
            color: '{surface.0}'
        }
    },
    dark: {
        root: {
            background: '{surface.50}',
            color: '{surface.950}'
        }
    }
};

export default {
    root,
    colorScheme
} satisfies TooltipDesignTokens;
